import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '@/directive/permission';
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import "./style/element-theme.css";
import "./style/reset.scss";
import http from "./axios";
import Navigation from "vue-navigation";
import { mapState } from 'vuex';

Vue.mixin({
    computed: {
		...mapState(['SYSTEM'])
	}
})

Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.use(ElementUI);
// router辅助组件
Vue.use(Navigation, { router, store, moduleName: 'navigation', keyName: 'v' });

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
